<template>
	<ul class="accordion" data-accordion data-multi-expand="true" data-allow-all-closed="true">
		<li class="accordion-item" data-accordion-item v-for="(item, key) in items" :key="`accordion-item-${key}`" ref="accordion-item-key" >
			<a href="#" class="accordion-title" v-if="item.title">
				{{ item.title }}
			</a>
			<div class="accordion-content" data-tab-content v-if="item.content" v-html="item.content" />
		</li>
	</ul>
</template>
<script>
	import foundation from '@/mixins/foundation.js'

	export default {
		name: 'Accordion',
		props: {
			items: {
				type: Array,
				default(){ return [] }
			}
		},
		mixins: [foundation]
	}
</script>
<style lang="scss" scoped>
	ul.accordion{
		li.accordion-item{
			a.accordion-title{
				display: flex;
				justify-content: space-between;
				align-items: center;
				font-weight: bold;

				&:after {
					content: '\f078';
					font-family: 'Font Awesome 5 Pro';
				}
			}

			&.is-active{
				a.accordion-title{
					&:after{
						content: '\f077';
					}
				}
			}
		}
	}
</style>